import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LogoutComponent } from './login/pages/logout/logout.component';
import { AdminLayoutComponent } from './admin-dashboard/admin-layout/admin-layout.component';
import { adminAuthGuard } from '@core/guard/admin-auth.guard';
import { mfaEnrolledGuard } from '@core/guard/mfa-enrolled.guard';
import { ConnectorConfigGuard } from '@core/guards/connector-config.guard';
import { planRequiredGuard } from '@core/guards/plan-required.guard';
import { TestEmailComponent } from './test-email.component';
import { ConnectorStatusComponent } from './setup/connector-status/connector-status.component';
import { ServerErrorComponent } from './error/server-error.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'setup/connectors',
    loadChildren: () =>
      import('./setup/connectors/connectors-setup.module').then(
        (m) => m.ConnectorsSetupModule,
      ),
  },
  {
    path: 'setup/connector-status',
    component: ConnectorStatusComponent,
  },
  {
    path: 'test-email',
    component: TestEmailComponent,
  },
  {
    path: 'dashboard',
    component: AdminLayoutComponent,
    loadChildren: () =>
      import('./admin-dashboard/admin-dashboard.module').then(
        (m) => m.AdminDashboardModule,
      ),
    // Apply connector capability guard to support BYOS mode; mfaEnrolledGuard
    // runs after adminAuthGuard so it always sees an authenticated session.
    canActivate: [adminAuthGuard, mfaEnrolledGuard, ConnectorConfigGuard],
    // Until the company has a plan, everything but the plan step, company,
    // billing and profile pages leads to the plan step (#943).
    canActivateChild: [planRequiredGuard],
  },
  {
    path: 'upgrade',
    redirectTo: '/dashboard/company/subscription-plans',
    pathMatch: 'full',
  },
  {
    path: 'error',
    component: ServerErrorComponent,
  },
  {
    path: 'account/expired',
    loadComponent: () =>
      import('./account/pages/account-expired/account-expired.component').then(
        (m) => m.AccountExpiredComponent,
      ),
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
